var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutreach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.33,129.91l22.54,20.81h29.56s7.58,1.51,7.2,8.33-4.93,8.71-7.58,8.71H96.88L63.15,138.59l-37.89-.38V103.74h47s7-2.17,19.7,9.47c10.66,9.8,35.75,28,24,37.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.8,97.36l-22.54-20.8H80.7S73.12,75,73.5,68.22s4.93-8.71,7.58-8.71h40.17L155,88.68l37.9.38v34.47h-47s-7.06,2.17-19.71-9.47c-10.66-9.8-35.74-27.95-24-37.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreach);
export default __webpack_public_path__ + "static/media/OUTREACH.1aafc3fb11a1cc2e68bb86d62dd92465.svg";
export { ForwardRef as ReactComponent };